import React, { useState } from "react";
import ViewMore from "./ViewMore";
import { Button, Modal } from "antd";
import { useFormik } from "formik";
import axiosInstance from "../../../../../../Services/axiosCommon";
import * as yup from "yup";
import { Link } from "react-router-dom";
import { NuInput } from "../../../../../../Components/Utils/Input";


function TableData({ item, getTask,id }) {
  const [update, setUpdate] = useState(false);
  const [value, setValue] = useState({
    today:""
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: value,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({

    }),
    onSubmit: async (value, { resetForm }) => {

      axiosInstance
      .put(`installation/${item?.Id}`,value)
      .then((res) => {
        resetForm()
        getTask()
        setUpdate(false)
      })
      .catch((error) => {
        console.log(error);
      });
    },
  });

  return (
    <>
      <tr className=" w-full ">
        <td className="py-2 px-1  text-xs text-center font-normal text-mainColor-400">
          {item?.serial_number || "#"}
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
        <Link className='hover:text-baseColor-primary text-mainColor-400'  to={`/progress/installation/view/${id}`} state={{data:item}}>   {item?.description|| "-"}</Link>
       
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
        <Link className='hover:text-baseColor-primary text-mainColor-400'  to={`/progress/installation/view/${id}`} state={{data:item}}>   {item?.division|| "-"}</Link>
         
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          {item?.unit || "-"}
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          {item?.quantity || "0"}
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          {item?.installed || "0"}
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          <div className=" w-full cursor-pointer " onClick={() => setUpdate(true)}>
            {item?.today || "0"}
          </div>
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          {item?.cumulative || "0"}
        </td>
        <td className="py-2 px-1  text-xs text-left font-normal text-mainColor-400">
          {item?.remaining || "0"}
        </td>
        <td className="py-2 px-1  text-xs text-center font-normal text-mainColor-400">
          <div className=" w-full flex justify-center items-center">
            <ViewMore id={item?.Id} getData={getTask} data={item} />
          </div>
        </td>
      </tr>

      <Modal
        open={update}
        title={"Today Update"}
        width={"30%"}
        className="my-modal"
        centered
        onCancel={() => setUpdate(false)}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
        <div className=" w-full flex flex-wrap">
        <NuInput
        type="number"
            label="Progress"
            formik={formik}
            placeholder="Progress"
            name="today"
            width="w-full"
            isRequired={true}
        /> 
            <Button
              htmlType="submit"
              size="large"
              className="w-11/12 bg-[#119DEE] text-white  mx-auto"
            >
              Filter 
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default TableData;
